import { RootState } from 'store';

export const chatSelector = (state: RootState) => state.chat;
export const chatLoadingSelector = (state: RootState) => state.chat.loading;
export const chatCoversationsSelector = (state: RootState) => state.chat.conversations;
export const chatSelectedConversationSelector = (state: RootState) => state.chat.selectedCoversation;
export const chatSelectedConversationMessagesSelector = (state: RootState) => state.chat.selectedCoversationMessages;
export const chatConnectionStateSelector = (state: RootState) => state.chat.connectionState;